"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDevice = exports.useIsDesktop = exports.useIsTablet = exports.useIsMobile = exports.useWindowWidth = exports.useWindowHeight = exports.useWindowSize = exports.Device = void 0;
var react_1 = require("react");
var Variables_1 = require("../Variables");
var Device;
(function (Device) {
    Device["Desktop"] = "DESKTOP";
    Device["Tablet"] = "TABLET";
    Device["Mobile"] = "MOBILE";
})(Device = exports.Device || (exports.Device = {}));
var useWindowSize = function () {
    var _a = (0, react_1.useState)({
        height: window.innerHeight,
        width: window.innerWidth,
    }), size = _a[0], setSize = _a[1];
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setSize({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return size;
};
exports.useWindowSize = useWindowSize;
var useWindowHeight = function () {
    var height = (0, exports.useWindowSize)().height;
    return height;
};
exports.useWindowHeight = useWindowHeight;
var useWindowWidth = function () {
    var width = (0, exports.useWindowSize)().width;
    return width;
};
exports.useWindowWidth = useWindowWidth;
var useIsMobile = function () {
    var width = (0, exports.useWindowWidth)();
    return width < Variables_1.breakpoints.Tablet;
};
exports.useIsMobile = useIsMobile;
var useIsTablet = function () {
    var width = (0, exports.useWindowWidth)();
    return width >= Variables_1.breakpoints.Tablet && width < Variables_1.breakpoints.Desktop;
};
exports.useIsTablet = useIsTablet;
var useIsDesktop = function () {
    var width = (0, exports.useWindowWidth)();
    return width >= Variables_1.breakpoints.Desktop;
};
exports.useIsDesktop = useIsDesktop;
var useIsDevice = function () {
    var width = (0, exports.useWindowWidth)();
    if (width >= Variables_1.breakpoints.Desktop) {
        return Device.Desktop;
    }
    else if (width >= Variables_1.breakpoints.Tablet) {
        return Device.Tablet;
    }
    else {
        return Device.Mobile;
    }
};
exports.useIsDevice = useIsDevice;
